package com.flowyride.core.domain.usecase

import com.flowyride.core.domain.geocoding.Geocoder
import com.flowyride.core.domain.gpx.toFixed
import com.flowyride.core.domain.model.GeoPoint
import com.flowyride.core.domain.model.Place
import com.flowyride.core.domain.util.suspendRunCatching

/** Names a spot picked on the map. Never fails: falls back to its coordinates. */
class ReverseGeocodeUseCase(private val geocoder: Geocoder) {

    suspend operator fun invoke(point: GeoPoint): Place =
        suspendRunCatching { geocoder.reverse(point) }.getOrNull()
            ?: Place(name = point.toCoordinatesLabel(), detail = null, point = point)
}

/** "45.77660, 6.11070" */
internal fun GeoPoint.toCoordinatesLabel(): String =
    "${latitude.toFixed(COORDINATES_LABEL_DECIMALS)}, ${longitude.toFixed(COORDINATES_LABEL_DECIMALS)}"

private const val COORDINATES_LABEL_DECIMALS = 5
